import { DocumentType, ValueOf } from 'support/types';
import { SidebarTableContent } from '../../Sidebar/SidebarTableContent/SidebarTableContent';
import { DocumentSummary } from '../DocumentSummary/DocumentSummary';
import { Summary } from '../DocumentSummary/types';
import { hasSummary } from '../DocumentSummary/helpers';
import { SidebarSection } from '../../Sidebar/SidebarSection/SidebarSection';

export const SidebarDocumentSummary = ({ documentType }: { documentType: ValueOf<DocumentType> | undefined }) => {
  if (!documentType && !hasSummary(documentType)) {
    return null;
  }

  return <DocumentSummary documentType={documentType} renderSummary={SummaryRenderer}></DocumentSummary>;
};

const SummaryRenderer = ({ summary }: { summary: Summary }) => {
  return (
    <SidebarSection>
      <SidebarTableContent
        sections={summary.content.map((items) =>
          items.filter((item) => (item.test ? item.test('view-document') : true)),
        )}
        footer={summary.footer}
      />
    </SidebarSection>
  );
};
